import React from "react";
import { Outlet } from "react-router-dom";

const RadiologyTest = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RadiologyTest;
